import React, { useState, useEffect, useRef, useLayoutEffect } from "react";

import classnames from "classnames";

import GoogleSuggest from "./GoogleSuggest";
import Date from "./Date";
import Time from "./Time";
import MapImg from "./MapImg";

import moment from "moment";

const MOMENT_DATE_FORMAT = "YYYY-MMM-DD";

import WhatDoYouDo from './WhatDoYouDo';
import DoesMyBirthtime from './DoesMyBirthtime';

function Form(props) {
  const [hour, setHour] = useState(12);
  const [formattedTime, setFormattedTime] = useState("");
  const [minute, setMinute] = useState(0);

  const [displayDate, setDisplayDate] = useState(
    moment().format(MOMENT_DATE_FORMAT)
  );
  const [day, setDay] = useState(moment().date());
  const [month, setMonth] = useState(moment().month());
  const [year, setYear] = useState(moment().year());

  const [placeId, setPlaceId] = useState(null);
  const [placeDesc, setPlaceDesc] = useState(null);
  const [latitude, setLatitude] = useState(null);
  const [longitude, setLongitude] = useState(null);

  const [placeValidation, setPlaceValidation] = useState("");
  const [dateValidation, setDateValidation] = useState("");

  const [dontKnowTime, setDontKnowTime] = useState(false);

  const firstUpdate = useRef(true);

  useLayoutEffect(() => {
    if (firstUpdate.current) {
      firstUpdate.current = false;
      return;
    } else {
      validatePlace();
    }
  }, [placeId, placeDesc, latitude, longitude]);

  useEffect(() => {
    validateDate();
  }, [year, month, day]);

  const onPlaceBlur = () => {
    validatePlace();
  };

  const setPlace = ({ placeId, placeDesc, latitude, longitude }) => {
    setPlaceId(placeId);
    setPlaceDesc(placeDesc);
    setLatitude(latitude);
    setLongitude(longitude);
  };

  const formSubmit = () => {
    if (validateAll()) {
      let formattedDateTime = `${displayDate} at ${formattedTime}`;

      if (dontKnowTime) {
        formattedDateTime = displayDate;
      }

      // if validates
      props.submit({
        formattedDateTime,
        placeId,
        placeDesc,
        latitude,
        longitude,
        minute,
        hour,
        day,
        month,
        year,
        dontKnowTime
      });
    }
  };

  const validateAll = () => {
    if (!validateDate() || !validatePlace()) {
      return false;
    }

    return true;
  };

  const checkDate = () => {
    if (day === null || month === null || year === null) {
      return false;
    } else {
      return true;
    }
  };

  const checkPlace = () => {
    if (
      placeId === null ||
      placeDesc === null ||
      latitude === null ||
      longitude === null
    ) {
      return false;
    } else {
      return true;
    }
  };

  const validateDate = () => {
    if (checkDate() === false) {
      setDateValidation("Enter a date");
      return false;
    } else if (year < 700 || year > 3000) {
      setDateValidation("Sorry date out of range");
      return false;
    }
    setDateValidation("");

    return true;
  };
  const validatePlace = () => {
    if (checkPlace() === false) {
      setPlaceValidation("Please enter a place.");
      return false;
    }
    setPlaceValidation("");
    return true;
  };

  const handleDateChange = (date) => {
    if (date === null) {
      setDay(null);
      setMonth(null);
      setYear(null);
      setDisplayDate("");
    } else {
      setDay(date.date());
      setMonth(date.month());
      setYear(date.year());
      setDisplayDate(date.format(MOMENT_DATE_FORMAT));
    }
  };

  let dateValidationClasses = classnames("invalid-feedback", {
    "make-iv": dateValidation,
  });

  let placeValidationClasses = classnames("invalid-feedback", {
    "make-iv": placeValidation,
  });

  return (
    <div className="form-container">
      <div className="form-row row">
        <div className="col">
          <MapImg mapKey={props.mapKey} latitude={latitude} longitude={longitude} />
        </div>
      </div>
      <div className="form-row row">
        <label className="col-sm-3">
          <span className="col-form-label">I WAS BORN IN:</span>
        </label>
        <div className="input-column col-sm-9">
          <GoogleSuggest
            mapKey={props.mapKey}
            placeValidation={placeValidation}
            setPlace={setPlace}
            onBlur={onPlaceBlur}
          />
        </div>
      </div>
      <div className="form-row form-row-warning row">
        <div className="col-sm-6 offset-sm-3">
          <div className={placeValidationClasses}>{placeValidation}</div>
        </div>
      </div>

      <div className="form-row row">
        <label className="col-sm-3">
          <span className="col-form-label">ON:</span>
        </label>
        <div className="input-column col-sm-9">
          <Date
            dateValidation={dateValidation}
            onDateChange={handleDateChange}
            year={year}
            month={month}
            day={day}
          />
        </div>
      </div>
      <div className="form-row form-row-warning row">
        <div className="col-sm-6 offset-sm-3">
          <div className={dateValidationClasses}>{dateValidation}</div>
        </div>
      </div>

      <div className="form-row row">
        <label className="col-sm-3">
          <span className="col-form-label">AT:</span>
        </label>
        <div className="input-column col-md-9">
          <Time
            hour={hour}
            minute={minute}
            setHour={setHour}
            formattedTime={formattedTime}
            setFormattedTime={setFormattedTime}
            setMinute={setMinute}
          />
        </div>
      </div>
      <div className="form-row row">
        <div className="input-column col-md-9 offset-md-3">
          <div className="check-form-cont">
            <label className="check-form-label">
              I don't know my birth time:
            </label>
            <input
              type="checkbox"
              className="dont-know-check"
              value={dontKnowTime}
              onChange={(e) => {
                setDontKnowTime(e.target.checked);
              }}
            />
          </div>
        </div>
      </div>
      <div className="form-row form-row-modal-question row">
        <div className="input-column col-md-9 offset-md-3">
          <DoesMyBirthtime/>
        </div>
      </div>
      <div className="form-row row">
        <div className="input-btn-column col-sm-6 offset-sm-3">
          <div>
            <button
              className="btn btn-primary btn-light submit-btn"
              onClick={formSubmit}
            >
              CAST MY CHART
            </button>
          </div>
          <WhatDoYouDo/>
        </div>
      </div>
    </div>
  );
}

export default Form;
